<template>
  <div>
    <div class="page-body">
      <div style="display: flex;justify-content: space-between">
        <div>
          <el-form :inline="true" class="demo-form-inline" label-position="right" label-width="100px" :model="searcheForm" >
            <el-form-item label="手机号:">
              <el-input placeholder="请输入手机号" clearable width="200px" v-model="searcheForm.phone" ></el-input>
            </el-form-item>
            <el-form-item label="关键字:">
              <el-input placeholder="请输入内容" clearable width="200px" v-model="searcheForm.content" ></el-input>
            </el-form-item>
            <el-button icon="el-icon-search" type="primary" @click="initFeedbackList">搜索</el-button>
          </el-form>
        </div>
        
      </div>
    </div>
    <!-- 表格 start -->
    <div style="margin-top: 30px">
      <el-table :data="feedbackList" stripe border v-loading="loading" element-loading-text="正在加载..." element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)" style="width: 100%" >
        <el-table-column prop="nickname" label="用户昵称" fixed align="center" width="200" ></el-table-column>
        <el-table-column prop="phoneNum" label="手机" width="200" align="center" fixed=""></el-table-column>
        <el-table-column prop="content" label="内容" width="500" align="center"></el-table-column>
        <el-table-column prop="imgs" label="附件信息" width="500" align="center">
          <template   slot-scope="scope" >

            <div v-for="(item,index) in scope.row.imgList" v-bind:key="index" style="width:70px;height:70px;display:inline">
              <el-image :src="item"  style="width:50px;height:50px;" :preview-src-list="scope.row.imgList" placeholder="图片加载失败"></el-image>
            </div>
          </template>     
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间" width="200" align="center"></el-table-column>
        <el-table-column fixed="right" width="200" align="center" label="操作">
          <template slot-scope="scope">
            <el-button @click="showEditEmpView(scope.row)" style="display:none">编辑</el-button>
            <el-button @click="deleteFeedback(scope.row)" type="danger">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div style="display: flex;justify-content: flex-end">
        <el-pagination
          background
          @current-change="currentChange"
          @size-change="sizeChange"
          layout="sizes, prev, pager, next, jumper, ->, total, slot"
          :total="total"
        ></el-pagination>
      </div>
    </div>
    <!-- 表格 END -->
    <el-dialog :title="title" :visible.sync="dialogVisible" width="500px">
      <div>
        <el-form
          :model="form"
          :rules="formRules"
          ref="formRef"
          label-position="right"
          label-width="100px"
        >
          <el-form-item label="OpenId:" prop="openId">
            <el-input
              size="mini"
              style="width: 100%"
              prefix-icon="el-icon-edit"
              v-model="form.openId"
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item label="昵称:" prop="nickname">
            <el-input
              size="mini"
              style="width: 100%"
              prefix-icon="el-icon-edit"
              v-model="form.nickname"
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item label="用户名:" prop="username">
            <el-input
              size="mini"
              style="width: 100%"
              prefix-icon="el-icon-edit"
              v-model="form.username"
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item label="地址:" prop="address">
            <el-input
              size="mini"
              style="width: 100%"
              prefix-icon="el-icon-edit"
              v-model="form.address"
            ></el-input>
          </el-form-item>
          <el-form-item label="备注信息:" prop="remark">
            <el-input
              size="mini"
              style="width: 100%"
              prefix-icon="el-icon-edit"
              v-model="form.remark"
              placeholder="请输入插座数量"
            ></el-input>
          </el-form-item>
          
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="doAddUser">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  deleteRequest,
  putRequest,
  getRequest,
  postRequest,
} from "../../utils/api";

import {apiListFeedbacks} from './api' ;

export default {
  name: "Feedback",
  data() {
    return {
      title: "", //模态窗口 标题
      searcheForm: {}, //搜索
      feedbackList: [], //列表数据
      loading: false,
      dialogVisible: false, // 是否显示 模态窗口
      total: 0,
      page: 1,
      size: 10,
      form: {},
      formRules: {},
    };
  },
  mounted() {
    this.initFeedbackList();
  },
  methods: {
    formatGender(row, column) {
      return row.gender == "1" ? "男" : row.gender == "0" ? "女" : "";
    },
    formatEnable(row, colum) {
      return row.enabled == true ? "是" : row.enabled == false ? "否" : "";
    },
    imgClicked(){
    },
    // 添加用户按钮
    showAddEmpView() {
      this.form = {};
      this.title = "新增";
      this.dialogVisible = true;
    },
    //编辑用户按钮
    showEditEmpView(data) {
      this.title = "编辑";
      this.form = data;
      this.dialogVisible = true;
    },
    // 删除用户
    deleteFeedback(data) {
      this.$confirm(
        "此操作将永久删除记录, 是否继续?",
        "提示",
        { confirmButtonText: "确定", cancelButtonText: "取消", type: "warning" }
      )
        .then(() => {
          deleteRequest(`/api/feedback/delete/${data.id}`).then(
            (resp) => {
              if (resp) {
                this.initFeedbackList();
              }
            }
          );
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    //添加卡 && 更新卡信息
    doAddUser() {
      this.$refs["formRef"].validate((valid) => {
        if (valid) {
          let url = "";
          let res;
          if (this.form.id) {
            url = `/api/chargeEquipment/updateEquipment`;
            res = putRequest(url, this.form);
          } else {
            url = `/api/chargeEquipment/addEquipment`;
            res = postRequest(url, this.form);
          }
          res.then((resp) => {
            if (resp) {
              this.dialogVisible = false;
              this.initFeedbackList();
            }
          });
        }
      });
    },
    // 页大小
    sizeChange(currentSize) {
      this.size = currentSize;
      this.initFeedbackList();
    },
    // 选择页
    currentChange(currentPage) {
      this.page = currentPage;
      this.initFeedbackList("advanced");
    },
    // 查询列表
   async  initFeedbackList(type) {
      this.loading = true;
      this.searcheForm.page=this.page;
      this.searcheForm.size=this.size;
      const response  = await apiListFeedbacks(this.searcheForm,{});
      let data  = response.data;
      this.feedbackList=data.list;
      this.total= data.total;
      this.loading=false;
    },
  },
};
</script>

<style>
.page-body {
  margin-top: 30px;
}
/* 可以设置不同的进入和离开动画 */
/* 设置持续时间和动画函数 */
.slide-fade-enter-active {
  transition: all 0.8s ease;
}

.slide-fade-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter, .slide-fade-leave-to
        /* .slide-fade-leave-active for below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}
</style>